import { FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions } from "@fxid/openapi-client";
import { initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import log from "loglevel";
import { useEffect } from "react";

/**
 * Переменная в замыкании для хранения инстанса Firebase Auth.
 * Не экспортируется напрямую для обеспечения инкапсуляции.
 */
let firebaseAuth: Auth | null = null;

/**
 * Устанавливает инстанс Firebase Auth для использования внутри фичи authV2.
 * Эту функцию необходимо вызвать один раз при инициализации приложения.
 * @param {Auth} auth - Инициализированный инстанс Firebase Auth.
 */
export const setFirebaseAuth = (auth: Auth) => {
	log.info("Firebase Auth instance has been set for authV2 feature");
	firebaseAuth = auth;
};

/**
 * Возвращает сохраненный инстанс Firebase Auth.
 * Выбрасывает ошибку, если инстанс не был установлен, что предотвращает
 * попытки аутентификации до инициализации Firebase.
 * @returns {Auth} Сохраненный инстанс Firebase Auth.
 */
export const getFirebaseAuth = (): Auth => {
	if (!firebaseAuth) {
		log.error("Firebase Auth instance is not initialized. Call setFirebaseAuth first.");
		throw new Error("Firebase Auth не был инициализирован. Вызовите setFirebaseAuth.");
	}
	return firebaseAuth;
};

export const useFirebaseAuth = (
	firebaseConfig: FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions | null | undefined
) => {
	useEffect(() => {
		if (firebaseConfig != null) {
			log.debug("Initializing firebase with config for authV2", firebaseConfig);
			const fbConf = {
				apiKey: firebaseConfig.ApiKey ?? undefined,
				authDomain: firebaseConfig?.AuthDomain ?? undefined,
				databaseURL: firebaseConfig.DatabaseUrl ?? undefined,
				projectId: firebaseConfig.ProjectId ?? undefined,
				storageBucket: firebaseConfig.StorageBucket ?? undefined,
				messagingSenderId: firebaseConfig.MessagingSenderId ?? undefined,
				appId: firebaseConfig?.AppId ?? undefined,
				measurementId: firebaseConfig?.MeasurementId ?? undefined
			};
			// Инициализируем приложение Firebase
			const app = initializeApp(fbConf);
			// Получаем инстанс Auth
			const auth = getAuth(app);
			// Устанавливаем его для использования в authV2
			setFirebaseAuth(auth);
		}
	}, [firebaseConfig]);
};
